<template>
  <div class="tm-order tm-order-check tm-senior-order-check">
    <preloader :is-visible="isLoading"/>
    <SeniorRetouchersInactivityTimer
      v-if="downtime !== null"
      :downtime="downtime"
      @is-loading="isLoading = $event"
      @retry="fetchDowntime"/>
    <div class="tm-background-dark-white tm-text-small uk-box-shadow-medium tm-senior-retoucher" v-else-if="empty_order === ''">
      <div class="uk-padding-xsmall">
        <div class="uk-grid uk-grid-small senior-retoucher" data-uk-grid>
          <!--левая часть-->
          <div class="uk-width-expand">
            <div class="uk-panel-scrollable" style="height: calc(100vh - 20px);resize: none;padding: 0;border: none;">
              <SeniorRetouchersMainPhotoBlock
                v-if="creteMainPhotoBlock"
                :main_photo_block="main_photo_block"
                :with-faces-visible="withFacesVisible"
                :zone-visible="zoneVisible"
                :order_number="order_number"
                :zone_photo="zone_photo"
                :afterVisible="afterVisible"
                :fullImageList="fullImageList"
                :isOutChat="isOutChat"
                @is-loading="isLoading = $event"
                @retry="reLoadPage"/>
              <!--ПРЕД/СЛЕД заказы-->
              <div class="uk-background-muted uk-padding-small uk-margin-small-top">
                <prev-orders-block
                  v-if="createPrevBlock"
                  :dataGridCol="'tm-child-width-1-9'"
                  :currRole="'senior-retoucher'"
                  class="uk-animation-slide-small-medium"/>
              </div>
            </div>
          </div>
          <!--правая часть-->
          <div class="uk-width-1-4 6" style="height: calc(100vh - 20px);">
            <!--шапка-->
            <order-card-head
              :order_number="order_number"
              :main_photo_before_with_faces="main_photo_before_with_faces"
              :role="user.role"
              @visible="withFacesVisible = $event"
              @visible-after="afterVisible = $event"/>
            <div class="uk-panel-scrollable" style="height: calc(100vh - 75px);resize: none;padding: 0;border: none;">
              <!--описание заказа-->
              <SeniorRetouchersInfoBlock
                v-if="createInfoBlock"
                :order_id="order_id"
                :main_photo_before_with_faces="main_photo_before_with_faces"
                :how_much_orders="how_much_orders"
                @zone-visible="zoneVisible = $event"
                @after-visible="afterVisible = $event"
                @zone_photo="zone_photo = $event"
                @loading="infoloading = $event"
                @order_cost_credits="cost = $event"
                @faces="faces = $event"
                @with-faces-visible="withFacesVisible = $event"
                @create_activities_buttons="createButtonsBlock = $event"/>
              <!--отметка NEWBIE-->
              <div v-if="junior_order === 'test'" class="uk-margin-small uk-label uk-label-warning uk-display-block uk-text-center">
                NEWBIE
              </div>
              <!--чат-->
              <div @mouseleave="isOutChat = true" @mousemove="isOutChat = false">
                <ChatBlock
                  :infoloading="infoloading"
                  v-if="order_chat !== '' && user"
                  :order_chat="order_chat"
                  :faces="faces"
                  :order_id="Number (order_id)"
                  :user="user.email"
                  :role="user.role"
                  @zone-visible="zoneVisible = $event"
                  @after-visible="afterVisible = $event"
                  @zone_photo="zone_photo = $event"
                  @loading="infoloading = $event"/>
              </div>
              <!--кнопки-->
              <ActivitiesOfSeniorRetoucher
                v-if="createButtonsBlock"
                :local_page_keys="local_page_keys"
                :loading="infoloading"
                :faces="makeFacesAsArrayOfObjects(faces)"
                :order_id="order_id"
                :main_photo_after="main_photo_after"
                :main_photo_before="main_photo_before"
                :role="role"
                :canvasWidth="canvasWidth"
                :canvasHeight="canvasHeight"
                :prev_status_order="prev_status_order"
                :order_number="order_number"
                :cost="cost"
                :order_chat="order_chat"
                @reload="reLoadPage"
                @isLoading="isLoading = $event"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Preloader from "@/pages/Dashboard/Components/Preloader";
import PrevOrdersBlock from "@/pages/Dashboard/Components/PrevOrdersBlock";
import OrderCardHead from "@/pages/Dashboard/Components/OrderCardHead";
import SeniorRetouchersMainPhotoBlock from "@/pages/Dashboard/Components/for_senjor_retouchers/SeniorRetouchersMainPhotoBlock";
import SeniorRetouchersInfoBlock from "@/pages/Dashboard/Components/for_senjor_retouchers/SeniorRetouchersInfoBlock";
import ActivitiesOfSeniorRetoucher from "@/pages/Dashboard/Components/for_senjor_retouchers/ActivitiesOfSeniorRetoucher";
import ChatBlock from "@/pages/Dashboard/Components/ChatBlock";
import SeniorRetouchersInactivityTimer from "@/pages/Dashboard/Components/for_senjor_retouchers/SeniorRetouchersInactivityTimer";

export default {
  name: 'SeniorRetouchersOrderCheck',
  data: () => ({
    createButtonsBlock: false,
    infoloading: true,
    createdowntime: false,
    createPrevBlock: false,
    createHistoryBlock: false,
    creteMainPhotoBlock: false,
    createInfoBlock: false,
    main_photo_block: null,
    main_photo_before_with_faces: null,
    afterVisible: true,
    downtime: null,
    withFacesVisible: false,
    zoneVisible: false,
    zone_photo: null,
    modal_photo: null,
    orderStatus: '',
    empty_order: '',
    isLoading: true,
    order_number: '',
    order_id: '',
    modal_photo_before_with_faces: '',
    faces: [],
    local_page_keys: {},
    order_chat: '',
    my_email: '',
    cost: 0,
    junior_order: false,
    main_photo_after: null,
    main_photo_before: null,
    canvasWidth: 560,
    canvasHeight: 360,
    prev_status_order: null,
    how_much_orders: null,
    role: '',
    is_orders_to_work: true,
    user: '',
    getterKey:0,
    fullImageList: {},
    isOutChat: true
  }),
  components: {
    PrevOrdersBlock,
    Preloader,
    ChatBlock,
    OrderCardHead,
    SeniorRetouchersMainPhotoBlock,
    SeniorRetouchersInfoBlock,
    SeniorRetouchersInactivityTimer,
    ActivitiesOfSeniorRetoucher
  },
  methods: {
    async fetchMainPhotoBlock() {
      try {
        let data = null;
        if (this.role === 'test-retoucher') {
          await this.$store.dispatch("order/mainPhotoBlockForRetoucher", 'senior-retoucher');
        } else {
          await this.$store.dispatch("order/mainPhotoBlockForRetoucher");
        }
        data = await this.$store.getters['order/mainPhotoBlock'];
        if (data) {
          if (typeof (data) !== 'string') {
            this.main_photo_before_with_faces =  !this.isURL(data.main_photo_before_with_faces) ? process.env.VUE_APP_API_BASE_URL.replace('api/v1', '') + data.main_photo_before_with_faces: data.main_photo_before_with_faces;
            this.order_number = data.order_number;
            this.order_id = data.order_id;
            this.junior_order = data.test_order
            this.fetchChatBlock();
            this.main_photo_block = data;
            this.creteMainPhotoBlock = true;
            this.createInfoBlock = true;
            this.createHistoryBlock = true;
            this.createPrevBlock = true;
            this.isLoading = false;
            this.prev_status_order = data.prev_status_order;
            this.how_much_orders = data.how_much_orders;
            if (Object.keys(data).includes('main_photo_after')) {
              this.main_photo_after = data.main_photo_after;
              this.canvasWidth = data.main_photo_after_width === '' ? this.canvasWidth : data.main_photo_after_width;
              this.canvasHeight = data.main_photo_after_height === '' ? this.canvasHeight : data.main_photo_after_height;
              this.main_photo_before = process.env.VUE_APP_API_BASE_URL.replace('api/v1', '') + data.main_photo_before;
            } else {
              this.main_photo_before = data.main_photo_before;
              this.canvasWidth = data.main_photo_before_width === '' ? this.canvasWidth : data.main_photo_after_height;
              this.canvasHeight = data.main_photo_before_height === '' ? this.canvasHeight : data.main_photo_before_height;
            }
            this.fullImageList = data.order_photo_file_list;
          } else {
            this.isLoading = false;
            this.empty_order = data;
            this.createdowntime = true;
          }
        } else {
          this.errors = this.local_page_keys.alert_failed_main_photo_block;
        }
      } catch (e) {
        alert(e);
      }
    },

    /**
     * Method for get data of unclosed downtime and availability of new orders in the queue
     * from DowntimeController (method index)
     * identifiable data: isLoading - define as false
     *                    orderStatus - type: string - if there is unclosed downtime defined as 'done'
     **/
    async fetchDowntime() {
      try {
        let data = null;
        await this.$store.dispatch("order/downtimeSeniorRetoucher");
        data = await this.$store.getters['order/downtimeSeniorRetoucher'];
        if (data) {
          if (data.order_in_work === true) {
            this.isLoading = false;
            this.downtime = null;
            await this.fetchMainPhotoBlock();
          } else {
            this.isLoading = false;
            this.downtime = data;
          }
        } else {
          this.errors = this.local_page_keys.alert_failed_downtime;
        }
      } catch (e) {

        alert(e);
      }
    },
    async fetchChatBlock() {
      try {
        let data;
        await this.$store.dispatch("order/historyBlock", this.order_id);
        data = await this.$store.getters["order/historyBlock"];
        if (data.status === 'ok') {
          this.order_chat = data.chat !== '' ? JSON.parse(data.chat) : '';
        } else {
          this.errors = this.local_page_keys.alert_failed_historyBlock;
          this.loading = false;
        }
      } catch (e) {
        alert(e);
      }
    },
    reLoadPage() {
      this.order_chat = '';
      this.isLoading = true;
      this.main_photo_before = null;
      this.main_photo_after = null;
      this.creteMainPhotoBlock = false;
      this.createInfoBlock = false;
      this.createPrevBlock = false;
      this.createButtonsBlock = false;
      this.fetchDowntime();
    },
    makeFacesAsArrayOfObjects(faces, updateThisFaces = false){

      let facesArr = [];

      if(!Array.isArray(faces)){
        if(0 in faces) facesArr.push({});
        Object.keys(faces).forEach(function(key){
          if(typeof Number(key) == 'number') facesArr[Number(key)] = faces[key];
        })
        return facesArr;
      }
      return faces;
    },
    isURL(str) {
      if(!str)
        return false;
      return str.startsWith('http://') || str.startsWith('https://');
    }
  },
  async created() {
    this.role = await this.$store.getters['profile/role'];
    this.local_page_keys = await this.$filtergetLocalisationPage('order-orderCheck');
    await this.$store.dispatch('profile/me');
    this.getterKey++;
    this.user = await this.$store.getters['profile/me'](this.getterKey);
    await this.fetchDowntime();
  },

}
</script>
<style>
.tm-file-name {
  word-break: break-all;
  line-height: 1;
}

.prev-img {
  width: 60px;
  height: 60px;
  background-color: #ccc
}

#files-area {
  border-radius: 6px;
  border: 3px dashed #e8e8e8;
  background-color: #f5f5f5;
  min-height: 100px;
}

.file-block {
  overflow: hidden;
  border-radius: 6px;
  background-color: rgba(144, 163, 203, 0.2);
  margin: 5px 0;
}

.tm-file-delete {
  cursor: pointer;
  padding: 10px;
}

/*.tm-button-add {*/
/*  padding: 0px 9px;*/
/*  border-radius: 50px;*/
/*}*/

.main-photo-dialog {
  height: 100%;
}

.left-part-main-photo {
  width: 100%;
}

.buttons {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.comments-button {
  border: #297a96 2px solid;
  border-radius: 5px;
  width: 75%;
  height: 90%;
  background: none;
  color: #3e3d3d;
  margin: 2px;
}

.scrollable-dialog {
  max-height: 80% !important;
  overflow-y: auto;
}

.checkFunctions {
  display: contents;
}

.image-compare-handle {
  color: #f10404;
  background-color: currentColor;
  cursor: ew-resize;
  transform: translateX(-50%) translateZ(0);
  width: 2px;
  z-index: 2;
  will-change: left;

}

/*.tm-block-img {*/
/*  background-color: #f0f0f0;*/
/*  width: 550px;*/
/*  height: 550px;*/
/*  display: -webkit-box;*/
/*  display: -ms-flexbox;*/
/*  display: flex;*/
/*  -webkit-box-align: center;*/
/*  -ms-flex-align: center;*/
/*  align-items: center;*/
/*  -webkit-box-pack: center;*/
/*  -ms-flex-pack: center;*/
/*  justify-content: center;*/
/*}*/

/*.tm-order-check .tm-block-img img {*/
/*  height: 100%;*/
/*  object-fit: contain;*/
/*}*/

/*.main-photo-image {*/
/*  min-width: 550px;*/
/*}*/

.display {
  display: none;
}

.cancel-order {
  margin: auto;
}

</style>